import { Component } from '@mycolorway/tao';
import autosize from 'autosize';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import editorFormMixin from 'next/javascripts/mixins/editor-form-mixin';
import editorDraftMixin from 'next/javascripts/mixins/editor-draft-mixin';
import 'next/stylesheets/components/project-progress-status-form.scss';

Component('tr-project-progress-status-form', {
  mixins: [eventListenerMixin, editorFormMixin, editorDraftMixin],

  connected() {
    this.titleField = this.querySelector('.title textarea');
    this.titleField.rows = 1;
    autosize(this.titleField);
    this.cancelButton = this.querySelector('.cancel-button');
    this.listenTo(this.cancelButton, 'click', this.handleFormCancel.bind(this));
  },

  ready() {
    this.titleField.focus();
  },

  handleFormCancel() {
    const cancel = this.namespacedTrigger('cancel');
    if (cancel) this.cancel();
  },

  cancel() {
    const section = closest(this, '.project-status') || closest(this, '.project-actions');
    if (section) {
      const statusContainer = section.querySelector('.status.hide');
      if (statusContainer) statusContainer.classList.remove('hide');
      const dropdownBtn = section.querySelector('.tr-dropdown-button.hide');
      if (dropdownBtn) dropdownBtn.classList.remove('hide');
    }
    this.remove();
  },

  disconnected() {
    this.stopListening();
  },
});
